import { render, staticRenderFns } from "./commentManagementInfo.vue?vue&type=template&id=d31dd9ac"
import script from "./commentManagementInfo.vue?vue&type=script&lang=js"
export * from "./commentManagementInfo.vue?vue&type=script&lang=js"
import style0 from "./commentManagementInfo.vue?vue&type=style&index=0&id=d31dd9ac&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports